import axios from '../../axios'
import { apiConstants } from '@const/apiConstants'

const URL = {
  queryUserStudyBehaviorList:
    'learn/app/report/clientapi/studyReport/queryUserStudyBehaviorList.do',
  getStudyRecordView:
    '/learn/app/report/clientapi/studyReport/getStudyRecordView.do',
}
export default {
  /**
   * 获取记录概况
   */
  getStudyRecordView: (userId: string) => {
    return axios.get(URL.getStudyRecordView, {
      params: {
        userId,
        isSupportAudioLive: 1,
        ver: apiConstants.VER_DATA,
      },
    })
  },
  /**
   * 获取学习足迹
   */
  queryUserStudyBehaviorList: (userId: string, statDate: string) => {
    return axios.get(URL.queryUserStudyBehaviorList, {
      params: {
        pageNumber: 1,
        userId,
        statDate,
        objectsPerPage: 100000,
        isSupportAudioLive: 1,
        ver: apiConstants.VER_DATA,
      },
    })
  },
}
